export default __webpack_public_path__ + "static/media/C2 - Logo.bb12dbc2.png";